import { isDefined } from "@clipboard-health/util-ts";
import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";
import { useWorkerGeoLocation } from "@src/appV2/Worker/useWorkerGeoLocation";
import { parseISO } from "date-fns";

import { useGetOpenShiftsForDates } from "../../Shift/Open/useGetOpenShiftsForDates";
import { useGetShiftDiscoveryDefaultDateRange } from "../../utils/useGetShiftDiscoveryDefaultDateRange";
import { DEFAULT_DISTANCE_IN_MILES_FILTER } from "../Filters/constants";
import { useShiftDiscoveryUserFiltersContext } from "../Filters/useUserFiltersContext";

interface UseListViewOpenShiftsDataProps {
  distance?: number;
  includeWindowedOutShifts?: boolean;
  favoriteWorkplacesOnly?: boolean;
  isShiftDoublesEnabled?: boolean;
}

export function useListViewOpenShiftsData(props: UseListViewOpenShiftsDataProps) {
  const {
    distance = DEFAULT_DISTANCE_IN_MILES_FILTER,
    includeWindowedOutShifts,
    favoriteWorkplacesOnly,
    isShiftDoublesEnabled = false,
  } = props;
  const { dates: dateStrings, includedStates } = useShiftDiscoveryUserFiltersContext();

  const workerGeoLocation = useWorkerGeoLocation();
  const windowedOutShiftsEnabled = useCbhFlag(CbhFeatureFlag.INCLUDE_WINDOWED_OUT_SHIFTS, {
    defaultValue: false,
  });

  const defaultDateRange = useGetShiftDiscoveryDefaultDateRange();

  const dates = dateStrings.map((dateString) => parseISO(dateString));

  const includeWindowedOutShiftsFilter = windowedOutShiftsEnabled
    ? (includeWindowedOutShifts ?? true)
    : false;

  const includeWindowedOut = includeWindowedOutShiftsFilter;

  return useGetOpenShiftsForDates({
    dates,
    dateRange: defaultDateRange,
    filter: {
      area: {
        latitude: workerGeoLocation?.latitude ?? 0,
        longitude: workerGeoLocation?.longitude ?? 0,
        radiusInMiles: distance,
      },
      includeWindowedOutShifts: includeWindowedOut,
      ...(favoriteWorkplacesOnly && { isFavoriteWorkplaceShift: true }),
      ...(includedStates?.length && { includedStates }),
    },
    enabled: isDefined(workerGeoLocation),
    includeOffers: isShiftDoublesEnabled,
  });
}
